<template>
  <div class="app-step-two-tabs-packages">
    <div class="app-step-two-tabs__wrapper">
      <div class="app-step-two-tabs-packages__body">
        <div class="app-step-two-tabs-packages__col">
          <div class="app-step-two-tabs-packages__line"></div>

          <loading-bar v-if="isPackageLoading"></loading-bar>
          <p v-else-if="!packages.length" class="app-step-two-tabs-packages__title">
            Packages could not be loaded. Please refresh the page and try again.
          </p>
          <template v-else>
            <h6 class="app-step-two-tabs-packages__title">Select a package</h6>
            <ul class="app-step-two-tabs-packages__list">
              <li
                v-for="packageItem in packages"
                :key="packageItem.id"
                class="app-step-two-tabs-packages__item app-step-two-tabs-packages-item"
                :class="{
                  selected:
                    packageItem?.singleCreditPrice?.id ===
                    selectedPackageItemId,
                }"
                @click="handlePackageClick(packageItem?.singleCreditPrice?.id)"
              >
                <h6 class="app-step-two-tabs-packages-item__title">
                  {{ packageItem.name }}
                  <span v-if="orderStore.isWriting">w / Writing</span>
                </h6>
                <p class="app-step-two-tabs-packages-item__price">
                  <span>$</span>

                  <span v-if="orderStore.isWriting">
                    {{ getWritingPriceFor(packageItem) }}
                  </span>
                  <span v-else>
                    {{ getRegularPriceFor(packageItem) }}
                  </span>

                  <span class="app-step-two-tabs-packages-item__arrow"
                    ><arrow-right
                  /></span>
                </p>
              </li>
            </ul>
          </template>
        </div>
        <div class="app-step-two-tabs-packages__col">
          <div class="app-step-two-tabs-packages__line"></div>
          <h6 class="app-step-two-tabs-packages__title">
            ... or click <span class="text-accent font-bold">next</span> to
            build your press release now
            <template v-if="buzzBuilderPackage">
              (starts at {{ buzzBuilderPackage.name }}).
            </template>
            <template v-else>.</template>
          </h6>
          <ul class="app-step-two-tabs-packages-instr">
            <li class="app-step-two-tabs-packages-instr-item">
              <p class="app-step-two-tabs-packages-instr-item__num">1</p>
              <p class="app-step-two-tabs-packages-instr-item__text">
                Your order starts at Buzz Builder.
              </p>
            </li>
            <li class="app-step-two-tabs-packages-instr-item">
              <p class="app-step-two-tabs-packages-instr-item__num">2</p>
              <p class="app-step-two-tabs-packages-instr-item__text">
                Choose your options on the next pages.
              </p>
            </li>
            <li class="app-step-two-tabs-packages-instr-item">
              <p class="app-step-two-tabs-packages-instr-item__num">3</p>
              <p class="app-step-two-tabs-packages-instr-item__text">
                The right side will track your charges and
                <span class="text-danger">alert you</span> to better value
                options.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <navigation-buttons
      :disabled-outer-condition="isPackageLoading || !packagePriceId"
      :loading="isLoading || isPackageLoading"
      @onPreviousButtonClick="handlePreviousClick"
      @onNextButtonClick="handleNextClick"
    ></navigation-buttons>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { usePackages } from '@core/composables/usePackages'
import { useOrder } from '@core/composables/order/useOrder'
import { useNavigationButtons } from '@modules/app-steps/step-two/navigation-buttons'

import LoadingBar from '@modules/ui/loading-bar.vue'
import ArrowRight from '@/assets/svg/arrow-right.svg?component'
import NavigationButtons from '@modules/app-steps/step-two/navigation-buttons/index.vue'
import {
  selectedPackageItemId,
  setSelectedPackageItemId,
} from '@modules/app-steps/step-two/tabs/packages/state'
import { useTabsStore } from '@/stores/tabs'
import { useOrderStore } from '@/stores/order'
import currency from 'currency.js'

const { packages, isLoading: isPackageLoading } = usePackages()
const { useUpdateOrder } = useOrder()
const { isLoading, updateOrder } = useUpdateOrder()
const { navigate } = useNavigationButtons()

const { getFrontendTabBuilder } = useTabsStore()

const orderStore = useOrderStore()

const handlePreviousClick = () =>
  updateOrder({ ...getFrontendTabBuilder() }, () => navigate())

const buzzBuilderPackage = computed(() =>
  packages.value.find(
    (packageItem) => packageItem.urlRewrite === 'buzz-builder'
  )
)

const packagePriceId = computed(
  () =>
    selectedPackageItemId.value ||
    buzzBuilderPackage.value?.singleCreditPrice?.id ||
    null
)

const handleNextClick = () => {
  if (!packagePriceId.value) return

  updateOrder(
    {
      ...getFrontendTabBuilder(true),
      packagePriceId: packagePriceId.value,
    },
    () => {
      navigate(true)
    }
  )
}
const handlePackageClick = (selectedId) => {
  if (!selectedId) return
  setSelectedPackageItemId(selectedId)
  handleNextClick()
}

const getWritingPriceFor = (packageItem) => {
  return currency(
    packageItem?.singleCreditPrice?.price + packageItem?.writingPrice
  )
}

const getRegularPriceFor = (packageItem) =>
  currency(packageItem?.singleCreditPrice?.price)
</script>
